"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.starterLegacyTierConfig = void 0;
exports.starterLegacyTierConfig = {
    hasStarterLegacyTier: true,
    showPayoutForm: true,
    showRebrandGuideAndAssetsLink: true,
};
